module.exports = __webpack_public_path__ + "static/img/bystage_05.982ea258.svg";